"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const signature_1 = require("../signature");
class GrainSuppressorNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'grainSuppressor')
            return new GrainSuppressorNode(obj['grain'].map(signature_1.GrainSignature.from));
        return null;
    }
    constructor(suppressedGrain) {
        super('Grain suppressor');
        this.suppressedGrain = suppressedGrain;
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    getSignature(datasetRepo) {
        if (!this.incoming[0])
            return null;
        let signature = this.incoming[0].getSignature(datasetRepo);
        signature.grains = signature.grains.filter(grain => !this.suppressedGrain.find(g => g.equals(grain)));
        return signature;
    }
    validate(datasetRepo) {
        if (!this.incoming[0])
            return false;
        return this.incoming[0].validate(datasetRepo);
    }
    serialize() {
        return super.serialize({
            type: 'grainSuppressor',
            grain: this.suppressedGrain.map(g => g.serialize()),
        });
    }
}
exports.default = GrainSuppressorNode;
